export class Header {
  constructor() {
    window.addEventListener('load', function show(e) {
      if(window.pageYOffset > 600) {
        document.querySelector('.header-area').classList.add('show');
      }
    });

    window.addEventListener('scroll', function show(e) {
      if(window.pageYOffset > 600) {
        document.querySelector('.header-area').classList.add('show');
        window.removeEventListener('scroll', show);
      }
    });
  }
}
